import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "../../../common/api/apiShared";
import { Result } from "../../../common/api/result";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { IDeleteLegalEntityDocumentDialogProps } from "./DeleteLegalEntityDocumentDialog";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useDeleteLegalEntityDocumentHook(props: IDeleteLegalEntityDocumentDialogProps) {
    const snackbar = useDotLegalSnackbar();

    const deleteMutation = useDotLegalMutation(deleteDocument);
    const deleteDocumentClick = (documentId: string) => {
        deleteMutation.mutateAsync(documentId!, {
            onSuccess: (response: Result<string>) => {
                props.onSaveCorrect();
                snackbar.show(createElement(Trans, { i18nKey: "documentDeleted", values: { document: props.selectedDocument!.name } }));
            },
        });
    };

    function deleteDocument(documentId: string) {
        return deleteHttp<string>(`/legalentity/${props.legalEntityId}/documents/${documentId}`);
    }

    return {
        deleteDocumentClick,
        inProgess: deleteMutation.isLoading,
    };
}
